import React from 'react';
import Icon from '../icon';
import styles from './style.less';

export interface GuideProps {
  onClose: () => void;
}

const Guide: React.FC<GuideProps> = ({ onClose, children }) => {
  return (
    <div className={styles.guideWrap}>
      <div className={styles.guide}>
        <div className={styles.guideContent}>
          {children}
        </div>
        <div className={styles.guideFooter} onClick={onClose}>
          <div className={styles.guideFooterDivider} />
          <div className={styles.guideFooterClose}>
            <Icon type="close" color="#fff" size={30} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guide;